/**
 * Which type the panel opens with when roles switched a ticket type off (#1544).
 *
 * "Ticket erstellen" presets `bug`; with bugs off and features on it must still
 * open, as a feature request. With both off nothing opens — the entries are
 * hidden then, this only guards a stray event.
 */
import type { AllowedTicketTypes } from '@/services/role-management-service'
import type { TicketType } from '@/services/bug-report-service'

export function openingType(preset: TicketType, allowed: AllowedTicketTypes): TicketType | null {
  if (allowed[preset]) return preset
  const other: TicketType = preset === 'bug' ? 'feature' : 'bug'
  return allowed[other] ? other : null
}
